// Centralized password strength policy (mirrors backend/password_policy.py)

export const PASSWORD_POLICY_MESSAGE =
  'Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number, and a special character.';

const SPECIAL_RE = /[!@#$%^&*()\-_=+[\]{};:,.<>/?\\|`~'"]/;

export function passwordChecks(pw) {
  const p = pw || '';
  return [
    { key: 'len', label: 'At least 8 characters', ok: p.length >= 8 },
    { key: 'upper', label: 'One uppercase letter (A-Z)', ok: /[A-Z]/.test(p) },
    { key: 'lower', label: 'One lowercase letter (a-z)', ok: /[a-z]/.test(p) },
    { key: 'digit', label: 'One number (0-9)', ok: /[0-9]/.test(p) },
    { key: 'special', label: 'One special character (e.g. ! @ # $ %)', ok: SPECIAL_RE.test(p) },
  ];
}

export function isPasswordStrong(pw) {
  return passwordChecks(pw).every((c) => c.ok);
}

// Compute a 0-4 strength score for visual indicators
export function passwordStrengthScore(pw) {
  const checks = passwordChecks(pw);
  const passed = checks.filter((c) => c.ok).length;
  // 0..1 -> 0, 2 -> 1, 3 -> 2, 4 -> 3, 5 -> 4
  if (passed <= 1) return 0;
  if (passed === 2) return 1;
  if (passed === 3) return 2;
  if (passed === 4) return 3;
  return 4;
}
